import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NgModule, CUSTOM_ELEMENTS_SCHEMA, APP_INITIALIZER } from '@angular/core';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { ProfileComponent } from './profile/profile.component';

import { MsalModule, MsalInterceptor, MsalGuard } from '@azure/msal-angular';
import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http';
import { AzurefunctionsComponent } from './azurefunctions/azurefunctions.component';
import { TenantChooserComponent } from './azuread/tenant-chooser/tenant-chooser.component';
import { GraphApiUrl, AzureManagementUrl, DefaultScope } from './azuread/azuread-helper.service';
import { Logger, LogLevel } from 'msal';
import { environment } from './../environments/environment';
import { StartOnboardingComponent } from './onboarding/start-onboarding/start-onboarding.component';
import { HomeComponent } from './home/home.component';
import { WizardStepWithErrorPipe, WizardStepVisiblePipe } from './shared/wizard.service';
import { SubscriptionChooserModal } from './onboarding/subscription-chooser-modal/subscription-chooser-modal.component';
import { RequestOnboardingComponent } from './requestonboarding/request-onboarding.component';
import { OffBoardingComponent } from './offboarding/offboarding.component';
import { CheckOffBoardingComponent } from './checkoffboarding/check-offboarding.component';
import { ProcessHistoryComponent } from './process-history/process-history.component';
import { ConfigLoaderService, appInitializerFactory } from './shared/config-loader.service';
import { MsalApplicationModule } from './app.msal-configuration.module';
import { TestfilesComponent } from './admin/testfiles/testfiles.component';
import { BlobErrorHttpInterceptor } from './shared/BlobErrorHttpInterceptor';

export function loggerCallback(logLevel, message, piiEnabled) {
  console.log(message);
}

@NgModule({
  declarations: [
    AppComponent,
    ProfileComponent,
    AzurefunctionsComponent,
    TenantChooserComponent,
    StartOnboardingComponent,
    HomeComponent,
    WizardStepWithErrorPipe,WizardStepVisiblePipe,
    SubscriptionChooserModal,
    RequestOnboardingComponent,
    OffBoardingComponent,
    CheckOffBoardingComponent,
    ProcessHistoryComponent,
    TestfilesComponent
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    FormsModule,
    BrowserAnimationsModule,
    HttpClientModule,
    ReactiveFormsModule,
    AppRoutingModule,
    
    MsalApplicationModule.forRoot()
  ],
  providers: [
    ConfigLoaderService,
    {
        provide: APP_INITIALIZER, 
        useFactory: appInitializerFactory, 
        deps: [ConfigLoaderService],
        multi: true
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: BlobErrorHttpInterceptor,
      multi: true
    }
  ],
  bootstrap: [AppComponent],
  schemas: [ CUSTOM_ELEMENTS_SCHEMA ]
})
export class AppModule { }
